export default __webpack_public_path__ + "static/media/tt-hoves-light.ca51b667.woff";